import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Form from "../../comman/form";
import Joi from "joi-browser";

class InternalReviewPopup extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
    };
  }

  schema = {
    comments: Joi.string().required().label("Comment"),
  };

  doSubmit = () => {
    const { data } = this.state;
    if (data["commentId"] !== null && data["commentId"] !== undefined) {
      this.props.handleEditComment(data);
    } else {
      this.props.handleSubmit(data);
    }
  };

  componentWillReceiveProps(nextProps) {
    const { selectedItem } = nextProps;
    if (selectedItem && selectedItem !== "") {
      this.setState({ data: selectedItem });
    } else {
      this.setState({ data: {}, errors: {} });
    }
  }

  render() {
    const { data } = this.state;
    const { showHide, handleModalShowHide, workflowTask, selectedItem, isLoading } = this.props;
    const isEditMode = data["commentId"] !== null && data["commentId"] !== undefined;
    const currentTask = workflowTask || this.props.workItem;
    const ciid = currentTask?.ciid || currentTask?.cIId || selectedItem?.ciid || "";
    const performer = selectedItem?.performer || "";

    return (
      <Modal
        show={Boolean(showHide)}
        onHide={handleModalShowHide}
        size="lg"
        dialogClassName="rt-tools-modal irp-modal"
        centered
        scrollable
        backdrop="static"
        keyboard={false}
      >
        <style>{`
          .modal-backdrop {
            z-index: 1080 !important;
          }
          .modal {
            z-index: 1090 !important;
          }
          .modal-backdrop.show {
            backdrop-filter: blur(8px) !important;
            -webkit-backdrop-filter: blur(8px) !important;
            background-color: rgba(15, 23, 42, 0.45) !important;
            opacity: 1 !important;
          }
          .modal.fade .irp-modal.modal-dialog {
            transform: scale(0.95) !important;
            transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
          }
          .modal.show .irp-modal.modal-dialog {
            transform: scale(1) !important;
          }
          .irp-modal {
            max-width: 90% !important;
            width: 780px !important;
            font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
            color: #1e293b !important;
          }
          .irp-modal .modal-content {
            border-radius: 0 !important;
            box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
            overflow: hidden !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
          }
          .irp-modal .modal-header {
            position: relative !important;
            display: block !important;
            padding: 22px 28px 18px !important;
            background: #ffffff !important;
            border-bottom: 1px solid #edf2f7 !important;
          }
          .irp-modal .rt-header-shell {
            display: flex !important;
            flex-direction: column !important;
            gap: 12px !important;
            width: 100% !important;
          }
          .irp-modal .rt-header-top {
            display: flex !important;
            justify-content: space-between !important;
            align-items: flex-start !important;
            gap: 16px !important;
            width: 100% !important;
          }
          .irp-modal .rt-header-main {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
            flex: 1 1 auto !important;
          }
          .irp-modal .rt-header-icon {
            width: 48px !important;
            height: 48px !important;
            min-height: 48px !important;
            border-radius: 0 !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            color: #171717 !important;
            background: #f5f5f5 !important;
            border: 1px solid #d4d4d4 !important;
            box-shadow: 0 2px 6px -2px rgba(15,23,42,0.08) !important;
            font-size: 18px !important;
            flex-shrink: 0 !important;
          }
          .irp-modal .rt-header-copy {
            display: flex !important;
            flex-direction: column !important;
            gap: 6px !important;
            min-width: 0 !important;
          }
          .irp-modal .rt-modal-title {
            display: inline-flex !important;
            align-items: center !important;
            margin: 0 !important;
            color: #1e293b !important;
            font-size: 18px !important;
            font-weight: 500 !important;
            line-height: 1.2 !important;
          }
          .irp-modal .rt-modal-title-text {
            display: inline-flex !important;
            align-items: center !important;
            gap: 10px !important;
            flex-wrap: wrap !important;
          }
          .irp-modal .rt-modal-title-badge {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            padding: 3px 8px !important;
            border-radius: 0 !important;
            font-size: 11px !important;
            font-weight: 600 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.04em !important;
            background: #171717 !important;
            color: #ffffff !important;
            border: 1px solid #171717 !important;
          }
          .irp-modal .rt-modal-meta-row {
            display: flex !important;
            align-items: center !important;
            flex-wrap: wrap !important;
            gap: 8px !important;
            font-size: 12px !important;
          }
          .irp-modal .rt-meta-chip {
            display: inline-flex !important;
            align-items: center !important;
            gap: 4px !important;
            background: #ffffff !important;
            padding: 3px 8px !important;
            height: 24px !important;
            min-height: 24px !important;
            box-sizing: border-box !important;
            border-radius: 0 !important;
            font-size: 11.5px !important;
            font-weight: 500 !important;
            color: #0f172a !important;
            border: 1px solid #cbd5e1 !important;
          }
          .irp-modal .rt-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 38px !important;
            height: 38px !important;
            padding: 0 !important;
            font-size: 14px !important;
            color: #64748b !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
            outline: none !important;
          }
          .irp-modal .rt-action-btn:hover {
            color: #1e293b !important;
            border-color: #94a3b8 !important;
            background: #f8fafc !important;
            transform: translateY(-1px) !important;
          }
          .irp-modal .rt-action-btn:hover i {
            color: #ef4444 !important;
          }
          .irp-modal .modal-body {
            padding: 24px !important;
            background: #ffffff !important;
          }
          .irp-modal .modal-body label,
          .irp-modal .modal-body .control-label,
          .irp-modal .modal-body .form-control-label {
            font-size: 12px !important;
            font-weight: 700 !important;
            color: #334155 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.04em !important;
            margin-bottom: 8px !important;
            display: block !important;
          }
          .irp-modal .modal-body textarea,
          .irp-modal .modal-body .form-control {
            font-size: 14px !important;
            font-weight: 400 !important;
            color: #1e293b !important;
            background-color: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            padding: 10px 14px !important;
            box-shadow: 0 1px 2px rgba(0,0,0,0.04) !important;
            transition: border-color 0.15s ease, box-shadow 0.15s ease !important;
            outline: none !important;
            min-height: 140px !important;
            resize: vertical !important;
          }
          .irp-modal .modal-body textarea:focus,
          .irp-modal .modal-body .form-control:focus {
            border-color: #2563eb !important;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12), 0 1px 2px rgba(0,0,0,0.05) !important;
            outline: none !important;
          }
          .irp-modal .modal-footer {
            background: #f8fafc !important;
            border-top: 1px solid #edf2f7 !important;
            padding: 16px 24px !important;
            display: flex !important;
            justify-content: flex-end !important;
            gap: 10px !important;
          }
          .irp-modal .wf-modal-footer-close-btn {
            display: inline-flex !important;
            align-items: center !important;
            gap: 7px !important;
            padding: 7px 16px !important;
            font-size: 13.5px !important;
            font-weight: 500 !important;
            color: #1e293b !important;
            background: #ffffff !important;
            border: 1px solid #cbd5e1 !important;
            border-radius: 0 !important;
            box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08) !important;
            outline: none !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
          }
          .irp-modal .wf-modal-footer-close-btn:hover {
            background: #f8fafc !important;
            color: #1e293b !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1px) !important;
          }
          .irp-modal .wf-modal-footer-close-btn:hover i {
            color: #ef4444 !important;
          }
          .irp-modal .wf-btn-save {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 8px !important;
            background: #2563eb !important;
            color: #ffffff !important;
            border: 1px solid #2563eb !important;
            padding: 7px 18px !important;
            border-radius: 0 !important;
            font-size: 13.5px !important;
            font-weight: 500 !important;
            cursor: pointer !important;
            transition: all 0.2s ease !important;
            outline: none !important;
            box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
          }
          .irp-modal .wf-btn-save:hover:not(:disabled) {
            background: #1d4ed8 !important;
            border-color: #1d4ed8 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3) !important;
          }
          .irp-modal .wf-btn-save:disabled {
            background: #cbd5e1 !important;
            border-color: #cbd5e1 !important;
            color: #94a3b8 !important;
            opacity: 0.85 !important;
            cursor: not-allowed !important;
            box-shadow: none !important;
            transform: none !important;
          }
          .irp-modal .text-danger,
          .irp-modal .alert-danger {
            font-size: 11.5px !important;
            color: #ef4444 !important;
            margin-top: 5px !important;
            font-weight: 500 !important;
            background: none !important;
            border: none !important;
            padding: 0 !important;
            display: block !important;
          }
        `}</style>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-pencil-square-o" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>{isEditMode ? "Edit Internal Note" : "Add Internal Note"}</span>
                      <span className="rt-modal-title-badge">Internal Note</span>
                    </span>
                  </h2>
                  <div className="rt-modal-meta-row">
                    <span className="rt-meta-chip">
                      <i className="fa fa-info-circle" style={{ color: "#0891b2" }} />
                      <span>{isEditMode ? "Update internal review note" : "Log note for internal team review"}</span>
                    </span>
                    {performer && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-user" style={{ color: "#9333ea" }} />
                        <span>{performer}</span>
                      </span>
                    )}
                    {ciid && (
                      <span className="rt-meta-chip">
                        <i className="fa fa-hashtag" style={{ color: "#d97706" }} />
                        <span>CIID {ciid}</span>
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={handleModalShowHide}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              {this.renderTextArea("comments", "Review Notes & Comments")}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={handleModalShowHide}
          >
            <i className="fa fa-times" aria-hidden="true" />
            Close
          </button>
          <button
            type="button"
            className="wf-btn-save"
            disabled={isLoading || this.validate()}
            onClick={this.handleSubmit}
          >
            {isLoading ? (
              <>
                <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                {isEditMode ? "Updating..." : "Saving..."}
              </>
            ) : (
              <>
                <i className="fa fa-check" aria-hidden="true" />
                {isEditMode ? "Update Note" : "Save Note"}
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default InternalReviewPopup;
